/* eslint-env browser */
/* global $ */

import Isotope from 'isotope-layout';

const $list = $('.product-list');
const $listItems = $list.find('.product-list-item');
const $grid = $('.product-list-items');
const $announceNoItems = $('.product-list__no-items');
// let $cards;
let $matchingProducts;
let gridAPI;

function init() {
	if (!$list.length) {
		return;
	}

	$(document).on('filter-change.product-list', filterItems);

	gridAPI = new Isotope($grid[0], {
		itemSelector: '.product-list-item',
		layoutMode: 'fitRows'
	});
}

function filterItems(e, filterParams) {

	$matchingProducts = $listItems.filter(function () {

		let isMatch = true;
		const productData = $(this).data();

		$.each(filterParams, function (field, filterValue) {

			if (filterValue === null || filterValue.indexOf(-1) > -1) {
				isMatch = true;
			} else if (Array.isArray(productData[field])) {
				const a = new Set(productData[field]);
				const b = new Set(filterValue);
				const intersection = new Set([...a].filter((val) => b.has(val)));
				isMatch = (intersection.size > 0);
			} else {
				isMatch = (productData[field] === filterValue);
			}

			return isMatch; // False breaks loop

		});

		return isMatch;

	});

	$listItems.removeClass('is-active');
	$matchingProducts.addClass('is-active');

	gridAPI.arrange({ filter: '.is-active' });

	if ($matchingProducts.length < 1 && !$announceNoItems.hasClass('is--active')) {
		$announceNoItems.addClass('is--active').show();
	} else if ($matchingProducts.length > 0 && $announceNoItems.hasClass('is--active')) {
		$announceNoItems.removeClass('is--active').hide();
	}
}


export default {
	init
};
